// import { Suspense } from 'react';
import { useEffect, useState } from 'react';
import AppBar from '../app/components/AppBar';
import { useAppStoreDispatch, useAppStoreSelector } from '../../store';
// import { fetchPortalsThunk, selectIsGuestMode } from '../portal/store';
import { Outlet } from 'react-router-dom';
import Loading from '../general/components/Loading';
import { useAuthGuard } from '../auth/Auth.hook';
import { fetchCategoriesThunk } from '../category/store';
import Footer from './components/Footer';
import Box from '@mui/material/Box';
// import { Spinner } from 'react-bootstrap';

export default function App() {
  useAuthGuard();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppStoreDispatch();
  // const navigate = useNavigate();
  const userState = useAppStoreSelector((state) => state.user);
  // const isGuest = useAppStoreSelector(selectIsGuestMode);
  // console.log('App rendering');

  useEffect(() => {
    const fetchPortalsOnComponentLoad = async () => {
      setLoading(true);
      try {
        await dispatch(fetchCategoriesThunk()).unwrap();
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    if (userState.data.token) {
      fetchPortalsOnComponentLoad();
    }
  }, [dispatch, userState.data.token]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <AppBar
        setAppLoading={setLoading}
      />

      <Box
        sx={{
          flex: 1,
          backgroundColor: "background.default",
        }}
      >
        {loading ? <Loading /> : <Outlet />}
      </Box>

      <Footer />
    </Box >
  );
}
